module.exports = __webpack_public_path__ + "assets/img/691db97688a0c73d784b58a7ff49b057.jpeg";